var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.showCountdownTimer === true && _vm.complete == false)?_c('v-layout',{staticClass:"countdown",attrs:{"row":"","align-center":""}},[_c('v-flex',{attrs:{"xs12":"","sm4":""}},[_c('v-icon',{staticClass:"pa-1"},[_vm._v(" access_time ")])],1),_c('v-flex',{attrs:{"xs10":""}},[_vm._v(" Session will expire in "+_vm._s(_vm.countdown)+" ")])],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }